import { render, staticRenderFns } from "./bd_stuInfo.vue?vue&type=template&id=584ba291"
import script from "./bd_stuInfo.vue?vue&type=script&lang=js"
export * from "./bd_stuInfo.vue?vue&type=script&lang=js"
import style0 from "./bd_stuInfo.vue?vue&type=style&index=0&id=584ba291&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports